import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { getInputValue, setInputValue } from '../../util/refUtils';
import { agregaTipoSiniestro, modificaTipoSiniestro } from '../../services/Siniestro/SiniestroService';
import { Dropdown } from 'primereact/dropdown';

const AdiTipoSiniestro = ({ funcSalir, datTipo }) => {
    const tiposSiniestros = [
        {
            label: 'MUERTE',
            code: 'MUERTE',
            path: 'M12,2C8.13,2 5,5.13 5,9V14C5,15.66 6.34,17 8,17H9V19C9,20.1 9.9,21 11,21H13C14.1,21 15,20.1 15,19V17H16C17.66,17 19,15.66 19,14V9C19,5.13 15.87,2 12,2M8.5,10.5C7.67,10.5 7,9.83 7,9C7,8.17 7.67,7.5 8.5,7.5C9.33,7.5 10,8.17 10,9C10,9.83 9.33,10.5 8.5,10.5M11,15H13V17H11V15M15.5,10.5C14.67,10.5 14,9.83 14,9C14,8.17 14.67,7.5 15.5,7.5C16.33,7.5 17,8.17 17,9C17,9.83 16.33,10.5 15.5,10.5Z'
        },
        {
            label: 'ARMADO',
            code: 'ARMA',
            path: 'M15.4 3L16.4 5H21V8H18.8L18.4 11H20.6L19 19C18.6 21 17 21 17 21H14C14 21 14 20 13 18C12 16 12 15 12 15L11 15C11 15 9.4 15.6 9 16C8.6 16.4 6 16.2 6 16.2L6 14.8C6 14.8 7 14.2 8 14C9 13.8 10 13 10 13V12L5 12C3.8 12 3 11.2 3 10V4.5C3 3.5 3.5 3 4.5 3H15.4ZM13.8 5H4.5V10H13.8V5Z'
        },
        {
            label: 'ACCIDENTE',
            code: 'ACCIDENTE',
            path: 'M19,10 L17.5,5.5 C17.2,4.6 16.3,4 15.3,4 L8.7,4 C7.7,4 6.8,4.6 6.5,5.5 L5,10 C4.4,10 4,10.4 4,11 L4,18 C4,18.5 4.5,19 5,19 L6,19 C6.5,19 7,18.5 7,18 L7,17 L17,17 L17,18 C17,18.5 17.5,19 18,19 L19,19 C19.5,19 20,18.5 20,18 L20,11 C20,10.4 19.6,10 19,10 Z M6.8,6.8 C7,6.3 7.5,6 8.1,6 L15.9,6 C16.5,6 17,6.3 17.2,6.8 L18.3,10 L5.7,10 L6.8,6.8 Z M7.5,15 C6.7,15 6,14.3 6,13.5 C6,12.7 6.7,12 7.5,12 C8.3,12 9,12.7 9,13.5 C9,14.3 8.3,15 7.5,15 Z M16.5,15 C15.7,15 15,14.3 15,13.5 C15,12.7 15.7,12 16.5,12 C17.3,12 18,12.7 18,13.5 C18,14.3 17.3,15 16.5,15 Z'
        },
        {
            label: 'ROBO',
            code: 'ROBO',
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
        },
        {
            label: 'INCENDIO',
            code: 'INCENDIO',
            path: 'M11.5,2C11.5,2 7.5,6 7.5,11.5C7.5,13.98 9.5,15.98 11.98,15.98C14.46,15.98 16.48,13.98 16.48,11.5C16.48,9.98 15.48,8.48 14.98,7.48L11.5,2M11.98,13.98C11.15,13.98 10.48,13.31 10.48,12.48C10.48,11.65 11.15,10.98 11.98,10.98C12.81,10.98 13.48,11.65 13.48,12.48C13.48,13.31 12.81,13.98 11.98,13.98Z'
        },
        {
            label: 'EXPLOSION',
            code: 'EXPLOSION',
            path: 'M22.61,15.22L20.45,16.58L22,19.25L19.34,20L19.46,23.11L16.42,22.25L14.73,24.81L12.43,22.8L9.67,24.45L8.74,21.5L5.7,21.84L5.59,18.73L2.91,17.44L4.93,15L3.1,12.56L5.68,10.66L4.29,7.91L7.26,7.56L6.92,4.53L9.84,5.43L11.5,3L13.79,4.96L16.5,3.25L17.43,6.17L20.47,5.85L20.59,8.96L23.27,10.27L21.26,12.7L22.61,15.22Z'
        },
        {
            label: 'SOSPECHOSO',
            code: 'VIGIA',
            path: 'M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z'
        },
        {
            label: 'ALERTA',
            code: 'ALERTA',
            path: 'M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16'
        }
    ];

    const refNombreTipo = useRef();
    const adiTipoToast = useRef();
    const [guardando, setGuardando] = useState(false);
    const [iconoSel, setIconoSel] = useState(null);

    useEffect(() => {
        const inicial = () => {
            if (datTipo?.configuracionDetId) {
                setInputValue(refNombreTipo, datTipo?.nombre);
                const param = JSON.parse(datTipo?.parametro);
                const buscado = tiposSiniestros.find((item) => item.code === param?.codeIcon);
                if (buscado) setIconoSel(buscado);
            }
        };
        inicial();
    }, [datTipo?.configuracionDetId, datTipo?.nombre]);

    const handleGuardar = async () => {
        //console.log('ICONO:..::.', iconoSel);
        const valNombre = getInputValue(refNombreTipo);
        if (!valNombre) {
            adiTipoToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar el campo Nombre.'
            });
            return;
        }
        if (!iconoSel.code) {
            adiTipoToast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe Seleccionar un Icono.'
            });
            return;
        }
        try {
            setGuardando(true);
            const CODIGO_CAB_TIPOSINIESTRO = 'SIN-0000-0000';
            const objData = {
                nombre: valNombre
            };
            const objParametro = {
                svgIcon: iconoSel.path,
                codeIcon: iconoSel.code
            };
            objData['parametro'] = JSON.stringify(objParametro);
            let data;
            if (datTipo?.configuracionDetId) {
                objData['configuracionDetId'] = datTipo?.configuracionDetId;
                data = await modificaTipoSiniestro(objData);
            } else {
                objData['codigo'] = CODIGO_CAB_TIPOSINIESTRO;
                data = await agregaTipoSiniestro(objData);
            }
            if (data.configuracionDetId) {
                adiTipoToast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha creado el Tipo Evento'
                });
            }
        } catch (error) {
            //console.error('Error al Guardar Tipo siniestro');
            adiTipoToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al Crear el Tipo de Evento'
            });
        } finally {
            setGuardando(false);
            funcSalir();
        }
    };

    const IconoSvg = ({ path, bgColor = '#f8f9fa', color = '#495057' }) => (
        <div className="flex align-items-center justify-content-center border-circle shadow-1 mr-3" style={{ width: '36px', height: '36px', backgroundColor: bgColor }}>
            <svg viewBox="0 0 24 24" width="20" height="20" fill={color} style={{ flexShrink: 0 }}>
                <path d={path} />
            </svg>
        </div>
    );

    // Paleta de colores predefinida para tipos
    const arrayColores = ['#ffebee', '#e8eaf6', '#e0f7fa', '#e8f5e9', '#fff8e1', '#fce4ec', '#f3e5f5', '#eef2f3'];
    const arrayTonos = ['#d32f2f', '#3f51b5', '#0097a7', '#388e3c', '#fbc02d', '#c2185b', '#7b1fa2', '#455a64'];

    const itemTemplate = (rawData) => {
        // Asignamos un color estético dependiendo de la inicial para diferenciar
        const charCode = rawData.label.charCodeAt(0) || 0;
        const idx = charCode % arrayColores.length;

        return (
            <div className="flex align-items-center p-2 border-round hover:surface-hover transition-colors transition-duration-150">
                <IconoSvg path={rawData.path} bgColor={arrayColores[idx]} color={arrayTonos[idx]} />
                <span className="font-medium text-700">{rawData.label}</span>
            </div>
        );
    };

    const valueTemplate = (option, props) => {
        if (option) {
            const charCode = option.label.charCodeAt(0) || 0;
            const idx = charCode % arrayColores.length;
            return (
                <div className="flex align-items-center">
                    <IconoSvg path={option.path} bgColor={arrayColores[idx]} color={arrayTonos[idx]} />
                    <span className="font-medium text-800">{option.label}</span>
                </div>
            );
        }
        return <span className="text-500 py-2">{props.placeholder}</span>;
    };

    return (
        <div className="card">
            <Toast ref={adiTipoToast} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-3">
                    <label>Codigo Padre: </label>
                </div>
                <div className="field col-12 md:col-9">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        Tipos de Evento
                    </span>
                </div>
                <div className="field col-12 md:col-6">
                    <label>Nombre Tipo Evento: </label>
                    <InputText
                        ref={refNombreTipo}
                        defaultValue=""
                        onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        maxLength={100}
                    />
                </div>
                <div className="field col-12 md:col-6">
                    <label>Icono del Evento: </label>
                    <Dropdown
                        value={iconoSel}
                        dataKey="code"
                        options={tiposSiniestros}
                        optionLabel="label"
                        placeholder="Seleccione un evento"
                        valueTemplate={valueTemplate}
                        itemTemplate={itemTemplate}
                        className="w-full md:w-20rem"
                        onChange={(evt) => setIconoSel(evt.value)}
                    />
                </div>
                <div className="field col-12 md:col-8">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-4 flex align-items-end">
                    <Button label="Guardar" icon="pi pi-save" loading={guardando} onClick={handleGuardar} />
                </div>
            </div>
        </div>
    );
};

export default AdiTipoSiniestro;
